import ReactApexChart from "react-apexcharts";

const chartOptions = {
    chart: {
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: false,
        },
        stacked: true,
    },
    tooltip: {
        theme: "dark",
    },
    dataLabels: {
        enabled: false,
    },
    xaxis: {
        categories: ["1", "3", "5", "7", "9", "11", "13", "15", "17", "19", "21", "23", "25", "27", "29"],
        labels: {
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        type: "numeric",
        labels: {
            formatter: (v) => {
                return '$' + v;
            },
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
    },
    stroke: {
        width: 1,
        colors: ['#fff', '#fff'],
    },
    legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'left',
        markers: {
            offsetX: -5,
            size: 5,
            shape: 'circle',
        },
        labels: {
            colors: ['#A3AED0', '#A3AED0']
        },
        itemMargin: {
            horizontal: 15,
        },
    },
    grid: {
        show: false,
    },
    plotOptions: {
        bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: false,
            // distributed: true,
        }
    }
};

const chartData = [
    {
      name: "Tithing",
      data: [50, 64, 48, 66, 168, 50, 64, 48, 66, 168, 50, 64, 48, 66, 168]
    },
    {
        name: "Special Contributions",
        data: [10, 23, 13, 12, 19, 10, 23, 13, 12, 19, 10, 23, 13, 12, 19]
    }  
];

function TotalDonations() {
    const newOptions = {
        ...chartOptions,
        colors: ['#707EAE', '#91B9A8'],
    };

    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      
        // These options can be used to round to whole numbers.
        trailingZeroDisplay: 'stripIfInteger'   // This is probably what most people
                                                // want. It will only stop printing
                                                // the fraction when the input
                                                // amount is a round number (int)
                                                // already. If that's not what you
                                                // need, have a look at the options
                                                // below.
        //minimumFractionDigits: 0, // This suffices for whole numbers, but will
                                    // print 2500.10 as $2,500.1
        //maximumFractionDigits: 0, // Causes 2500.99 to be printed as $2,501
    });

    return (
        <>
            <div className="flex-1 relative items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
                {/* header */}
                <div className="flex">
                    <div className="flex-1">
                        <p className="text-gray-700">Total donations</p>
                        <p>
                            <span className="text-2xl font-bold mr-2">{ currencyFormatter.format(37156.11) }</span>
                        </p>
                    </div>
                    <div>
                        <select className="flex-none bg-[transparent] h-12 text-sm text-gray-700 rounded-xl pr-4 outline-none rounded-2xl p-[8px] mr-4">
                            <option>Monthly</option>
                        </select>
                    </div>
                </div>

                {/* chart */}
                <div className="block h-[300px]">
                    <div className="h-full w-full">
                        <ReactApexChart
                            options={newOptions}
                            series={chartData}
                            type="bar"
                            width="100%"
                            height="100%"
                        />
                    </div>
                </div>
            </div>

        </>
    );
}

export default TotalDonations;
